(function () {
  function initSlider(root) {
    var minInput = root.querySelector('[data-role="min"]');
    var maxInput = root.querySelector('[data-role="max"]');
    var fill = root.querySelector('[data-role="range-fill"]');
    var minDisplay = root.querySelector('[data-role="min-display"]');
    var maxDisplay = root.querySelector('[data-role="max-display"]');
    if (!minInput || !maxInput || !fill) return;

    var rangeMax = parseFloat(minInput.max) || 0;
    var symbol = (minDisplay.textContent.match(/^\D+/) || [''])[0];

    function update() {
      var minVal = parseFloat(minInput.value);
      var maxVal = parseFloat(maxInput.value);

      if (minVal > maxVal) {
        var tmp = minVal;
        minVal = maxVal;
        maxVal = tmp;
      }

      var minPct = rangeMax ? (minVal / rangeMax) * 100 : 0;
      var maxPct = rangeMax ? (maxVal / rangeMax) * 100 : 100;

      fill.style.left = minPct + '%';
      fill.style.right = (100 - maxPct) + '%';

      if (minDisplay) minDisplay.textContent = symbol + Math.round(minVal);
      if (maxDisplay) maxDisplay.textContent = symbol + Math.round(maxVal);
    }

    minInput.addEventListener('input', function () {
      if (parseFloat(minInput.value) > parseFloat(maxInput.value)) {
        minInput.value = maxInput.value;
      }
      update();
    });

    maxInput.addEventListener('input', function () {
      if (parseFloat(maxInput.value) < parseFloat(minInput.value)) {
        maxInput.value = minInput.value;
      }
      update();
    });

    update();
  }

  document.querySelectorAll('.price-slider').forEach(initSlider);

  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('.price-slider').forEach(initSlider);
  });
})();
